import { Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import Head from "../components/commons/Head";
import Item from '../components/commons/Item';
import FanfareDialog from '../components/fanfares/FanfareDialog';
import { IFanfare } from '../models/IFanfare';
import { IWording } from "../models/IWording";

const fanfaresWordings: IWording = require("../assets/configuration/wordings/fanfares.json");
const fanfaresDatabase: IFanfare[] = require("../assets/configuration/database/fanfares.json");

const FanfaresView = () => {

    const {id} = useParams();
    const [fanfare, setFanfare] = useState({} as IFanfare);
    const [fanfares, setFanfares] = useState([] as IFanfare[]);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        setFanfares(shuffleFanfares())

        if (id) {
            const f = filterFanfareById(id);
            if (f.name) openDialog(f);
        }
    }, [id]);
    
    const openDialog = (fanfare: IFanfare) => {
        setFanfare(fanfare);
        setOpen(true);
    }

    const handleClose = () => setOpen(false);

    const filterFanfareById = (id: string): IFanfare => {
        const filteredFanfares = fanfaresDatabase.filter(f => f.id === id);
        return filteredFanfares.length > 0 ? filteredFanfares[0] : {} as IFanfare;
    }

    const shuffleFanfares = () => fanfaresDatabase.slice().sort(() => 0.5 - Math.random());

    return <>
        <Head title={fanfaresWordings.title} description={fanfaresWordings.description} />

        <Grid container spacing={2} sx={{marginTop: '40px'}}>
            {fanfares.map(fanfare =>
                <Grid item key={fanfare.name} xs={6} md={4} lg={2} xl={2}>
                    <Item label={fanfare.name} image={fanfare.image} fontSize={20} onClick={() => openDialog(fanfare)}/>
                </Grid>)
            }
        </Grid>

        {open && <FanfareDialog fanfare={fanfare} open={open} onClose={handleClose} />}
    
    </>
}

export default FanfaresView;